<template>
  <div class="footer">
    <modal
      name="modszertan"
      height="auto"
      width="70%"
      :scrollable="true"
    >
      <button @click="$modal.hide('modszertan')">
        X
      </button>
      <div class="modaltext">
        <div class="modtitle">Módszertan</div>
        <p>A cégek értékelésében amerikai anyalapunk módszertanát vettük alapul. Ahol tudtunk, az EBITDA alapján számoltunk, és
          a cégbírósági adatokat vettük figyelembe. A nemzetközi vállalatértékelési gyakorlatnak megfelelően iparági szorzót alkalmaztunk.
          Itt Aswath Damodaran, a New York University professzorának listáját használtuk kiindulásnak,
          de cégértékelési szakemberekkel és régiós testvérlapjainkkal együtt a szorzókat a régióra, illetve a magyar piacra szabtuk,
          ahol ez szükséges volt. Az így kapott értékhez hozzáadtuk a cég rendelkezésére álló készpénzállományt,
          és kivontuk belőle a hiteleket (a nagyobb holdingoknál mindig a konszolidált beszámolókat vettük alapul).</p>
        <p>Az ingatlanos, vagyonkezelő vagy pénzügyi cégeknél a társaságokban felhalmozott vagyont (az ingatlanok, eszközök,
          befektetések értékét) néztük, és az amerikai Forbes módszertana szerint az összes kötelezettséget számba vettük.</p>
        <p>Az osztalékoknál levontuk az adókat, továbbá ahol tudtuk, felmértük a milliárdosok egyéb érdekeltségeinek finanszírozási igényét,
          és azt is levontuk az osztalékból, illetve beszámítottuk az elmúlt évek osztalékainak egy részét is. Mindig nyilvánosan
          elérhető adatokból dolgozunk.</p>
        <p>Mindig a legfrissebb elérhető adatokat vettük alapul, a legtöbb – nem nyilvános – társaságnál ez a
          2017. január 1-től 2017. december 31-ig záródó üzleti évre leadott beszámolókat jelenti.
          Részvényeknél a legfrissebb adatokkal számoltunk. A vagyonbecslés zárása: 2018. december 5.</p>
        <p>Az adatok összegyűjtésében a Bisnode PartnerControl volt segítségünkre. A cégek felértékelésében tanácsadócégek
          M&nbsp;A szakértői segítettek minket.</p>
        <img
          src="../assets/img/modszertan-table.jpg"
          alt="táblázat"
        >
      </div>
    </modal>
    <div class="text">
      <div
        class="modszertan"
        @click="$modal.show('modszertan')"
      >Módszertan</div>
      <div class="szerk">
        Számolta, írta, szerkesztette: Zsiborás Gergő, Bánati Anna és Sándor Krisztián.
      </div>
    </div>
    <div class="logo">
      <a
        href="https://forbes.hu"
        target="_blank"
      >Tovább a <img
          class="forbeslogo"
          src="../assets/img/forbes-white.svg"
          alt="Forbes"
        > .hu-ra</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {

  },
  methods: {
    show() {
      this.$modal.show('modszertan');
    },
    hide() {
      this.$modal.hide('modszertan');
    },
  },
};
</script>

<style scoped lang="css">
.footer {
  font-size: 18px;
  grid-template-rows: auto;
  grid-template-columns: 20px 0.5fr 0.5fr 20px;
  padding: 10px 0;
}
.text {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  justify-self: start;
  align-self: center;
}
.szerk,
.modszertan {
  color: #fff;
}
.modszertan {
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: underline;
  cursor: pointer;
  letter-spacing: 1px;
}
.szerk {
  font-size: 12px;
  font-style: italic;
  margin-top: 3px;
}
.logo {
  grid-column: 3 / 4;
  grid-row: 1 / 2;
  justify-self: end;
  align-self: center;
}
a {
  color: #fff;
  text-decoration: none;
}
.forbeslogo {
  height: 30px;
  width: 95.28px;
  vertical-align: sub;
}
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.85);
}
.modaltext {
  font-size: 15px;
  line-height: 1.3;
  padding: 15px;
}
.modtitle {
  font-weight: 700;
  font-size: 18px;
}
.modaltext p {
  margin-block-start: 5px;
  margin-block-end: 5px;
}
.modaltext img {
  max-width: 100%;
}
.v--modal-overlay button {
  color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  border: none;
  background-color: #000;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
@media screen and (max-width: 767px) {
  .footer {
    font-size: 14px;
  }
}
@media screen and (max-width: 540px) {
  .footer {
    grid-template-rows: auto auto;
    grid-row-gap: 15px;
    padding: 15px 0;
  }
  .text {
    grid-column: 2 / 4;
    grid-row: 1 / 2;
    justify-self: center;
  }
  .logo {
    grid-column: 2 / 4;
    grid-row: 2 / 3;
    justify-self: center;
    align-self: center;
  }
  .szerk,
  .modszertan {
    text-align: center;
  }
}
</style>
